import { ArrowRight, MapPin } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { HERO_IMAGE } from "@/lib/site";

export default function Hero() {
  return (
    <section className="relative -mt-20 h-[100svh] min-h-[640px] w-full overflow-hidden" data-testid="hero-section">
      <img
        src={HERO_IMAGE}
        alt="Cabin nestled under towering gums on a sunlit forest path at Shady Acres Caravan Park, Ballarat"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-sa-ink/95 via-sa-ink/40 to-sa-ink/10" />
      <div className="absolute inset-x-0 bottom-0 max-w-7xl mx-auto px-6 md:px-10 pb-32 md:pb-40">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-sa-bg/90 mb-6">
            <MapPin size={16} weight="duotone" className="text-sa-accent" />
            <span className="overline text-sa-accent">Ballarat · Victoria</span>
          </div>
          <h1
            className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] text-sa-bg"
            data-testid="hero-headline"
          >
            Caravan park in Ballarat <em className="italic font-light">— under the gums.</em>
          </h1>
          <p className="mt-8 text-sa-bg/85 text-lg md:text-xl leading-relaxed max-w-xl">
            Well-maintained cabins in Ballarat, spacious powered caravan sites and serene camping — just 90 minutes from Melbourne, set across twelve acres of native bushland.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/book" className="btn-primary" data-testid="hero-book-btn">
              Book your stay <ArrowRight size={18} weight="bold" />
            </Link>
            <Link
              to="/accommodation"
              className="text-sa-bg/90 hover:text-sa-bg underline underline-offset-8 decoration-sa-accent decoration-2 px-2 py-3"
              data-testid="hero-explore-btn"
            >
              Explore stays
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
